import { isEmptyObject, isObject, isUndefined } from '@philips-internal/oswald-ui-utils';
const isDefined = (value) => (!isUndefined(value) && value !== null && value !== '' && (!isEmptyObject(value) || !isObject(value)));
const REQUIRED = 'required';
function RequiredValidator(value) {
    const valid = Array.isArray(value) ? Boolean(value.length) : isDefined(value);
    return [{
            message: 'tws.validator.required',
            name: REQUIRED,
            valid,
        }];
}
export { REQUIRED, RequiredValidator, };
export default RequiredValidator;
//# sourceMappingURL=required.js.map